<template>
    <v-container grid-list-lg>
        <promo />
        <image-category-promo />
    </v-container>
</template>

<script>
    import Promo from '../components/HomePage/Promo'
    import ImageCategoryPromo from "../components/HomePage/ImageCategoryPromo";

    export default {
        name: 'Homepage',
        components: {
            Promo,
            ImageCategoryPromo
        }
    }
</script>
